import { ArrowLeft } from '@phosphor-icons/react';
import { withMagneticIcon } from '../withMagneticIcon.js';

const Icon = withMagneticIcon(ArrowLeft);
Icon.displayName = "ArrowLeft";

export { Icon as ArrowLeft };
//# sourceMappingURL=ArrowLeft.js.map
